import React from 'react'
export default () =>
  <svg version="1.1" id="Layer_1" x="0px" y="0px"
  	 viewBox="0 0 223.7 57.3" >
  <path fill="#582D82" d="M221.7,57.3H2c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h219.7c1.1,0,2,0.9,2,2v53.3
  	C223.7,56.4,222.8,57.3,221.7,57.3z"/>
  <g>
  	<g>
  		<path fill="#FFFFFF" d="M23.1,38.4l6.7-20.8c0.4-1.1,1.2-1.7,2.2-1.7c1.2,0,2.3,0.8,2.3,2.2c0,0.3,0,0.6-0.1,0.9l-6.7,20.8
  			c-0.4,1.1-1.2,1.7-2.2,1.7c-1.2,0-2.3-0.8-2.3-2.2C23,39,23,38.7,23.1,38.4z"/>
  		<path fill="#FFFFFF" d="M31.9,38.4l6.7-20.8c0.4-1.1,1.2-1.7,2.2-1.7c1.2,0,2.3,0.8,2.3,2.2c0,0.3,0,0.6-0.1,0.9l-6.7,20.8
  			c-0.4,1.1-1.2,1.7-2.2,1.7c-1.2,0-2.3-0.8-2.3-2.2C31.7,39,31.8,38.7,31.9,38.4z"/>
  	</g>
  	<g>
  		<path fill="#FFFFFF" d="M55,28.6c0-2.9,0.2-4.1,0.5-4.9c0.8-2.5,2.7-3.8,5.5-3.8c2.4,0,4.3,1.1,5.1,2.8c0,0.1,0.1,0.3,0.1,0.4
  			c0,0.4-0.3,0.7-0.7,0.7c-0.2,0-0.4-0.2-0.6-0.5c-0.8-1.3-2.1-2.1-4-2.1c-2.1,0-3.5,1-4.1,2.9c-0.2,0.7-0.4,1.7-0.4,4.5
  			s0.2,3.9,0.4,4.5c0.6,1.9,2,2.9,4.1,2.9c2,0,3.5-1,4.1-2.8c0.2-0.7,0.4-1.6,0.4-3.2c0-0.1,0-0.2-0.1-0.2h-3.6
  			c-0.4,0-0.7-0.3-0.7-0.7s0.2-0.7,0.7-0.7h4.5c0.4,0,0.7,0.3,0.7,0.7v0.6c0,1.7-0.2,3-0.4,3.8c-0.8,2.5-2.8,3.8-5.5,3.8
  			c-2.8,0-4.7-1.3-5.5-3.8C55.2,32.7,55,31.6,55,28.6z"/>
  		<path fill="#FFFFFF" d="M71,20.8c0-0.4,0.3-0.7,0.7-0.7h8.9c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-8c-0.1,0-0.1,0-0.1,0.2v6
  			c0,0.1,0.1,0.2,0.1,0.2h6.8c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-6.8c-0.1,0-0.1,0-0.1,0.2v6.3c0,0.1,0.1,0.2,0.1,0.2h8
  			c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-8.9c-0.4,0-0.7-0.2-0.7-0.7V20.8z"/>
  		<path fill="#FFFFFF" d="M88.4,36.5V21.6c0-0.1-0.1-0.2-0.1-0.2h-4.5c-0.5,0-0.7-0.3-0.7-0.7c0-0.4,0.2-0.7,0.7-0.7h10.7
  			c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-4.5c-0.1,0-0.1,0-0.1,0.2v14.8c0,0.5-0.3,0.8-0.7,0.8C88.7,37.2,88.4,37,88.4,36.5
  			z"/>
  		<path fill="#FFFFFF" d="M103.7,35.7c-0.2-0.2-0.4-0.4-0.4-0.7c0-0.3,0.3-0.7,0.7-0.7c0.2,0,0.4,0.1,0.5,0.2c1.1,0.8,2.7,1.5,4.5,1.5
  			c2.7,0,4.4-1.4,4.4-3.5c0-1.7-0.9-2.9-4.1-3.3l-0.8-0.1c-3.3-0.4-4.9-2-4.9-4.5c0-2.9,2.1-4.8,5.3-4.8c1.8,0,3.3,0.5,4.4,1.1
  			c0.3,0.2,0.5,0.4,0.5,0.7c0,0.4-0.3,0.7-0.7,0.7c-0.2,0-0.3-0.1-0.5-0.1c-1.1-0.6-2.3-1-3.7-1c-2.5,0-3.8,1.4-3.8,3.3
  			c0,1.7,1.1,2.9,4,3.2l0.8,0.1c3.4,0.4,5,2,5,4.6c0,2.9-2,4.9-6,4.9C106.9,37.4,105,36.6,103.7,35.7z"/>
  		<path fill="#FFFFFF" d="M122.4,36.5V21.6c0-0.1-0.1-0.2-0.1-0.2h-4.5c-0.5,0-0.7-0.3-0.7-0.7c0-0.4,0.2-0.7,0.7-0.7h10.7
  			c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7H124c-0.1,0-0.1,0-0.1,0.2v14.8c0,0.5-0.3,0.8-0.7,0.8
  			C122.7,37.2,122.4,37,122.4,36.5z"/>
  		<path fill="#FFFFFF" d="M130.6,36.3l5.6-15.5c0.2-0.5,0.5-0.7,0.9-0.7s0.7,0.2,0.9,0.7l5.5,15.5c0,0.1,0.1,0.2,0.1,0.3
  			c0,0.4-0.3,0.6-0.7,0.6c-0.4,0-0.6-0.2-0.7-0.5l-1.4-4h-7.4l-1.4,4c-0.1,0.3-0.3,0.5-0.7,0.5c-0.4,0-0.7-0.2-0.7-0.6
  			C130.6,36.5,130.6,36.4,130.6,36.3z M140.3,31.3l-3.2-8.9h-0.1l-3.2,8.9H140.3z"/>
  		<path fill="#FFFFFF" d="M156.6,36.8l-3.5-7.2h-0.2h-4.4c-0.1,0-0.1,0-0.1,0.2v6.8c0,0.5-0.3,0.8-0.7,0.8c-0.4,0-0.7-0.3-0.7-0.8V20.8
  			c0-0.4,0.3-0.7,0.7-0.7h5.3c3.2,0,5.1,1.8,5.1,4.7c0,2.4-1.3,4-3.5,4.5l3.4,6.8c0.1,0.1,0.1,0.2,0.1,0.3c0,0.3-0.2,0.7-0.7,0.7
  			C157,37.2,156.8,37.1,156.6,36.8z M156.6,24.8c0-2.1-1.3-3.3-3.7-3.3h-4.4c-0.1,0-0.1,0-0.1,0.2V28c0,0.1,0.1,0.1,0.1,0.1h4.4
  			C155.3,28.2,156.6,27,156.6,24.8z"/>
  		<path fill="#FFFFFF" d="M165.8,36.5V21.6c0-0.1-0.1-0.2-0.1-0.2h-4.5c-0.5,0-0.7-0.3-0.7-0.7c0-0.4,0.2-0.7,0.7-0.7h10.7
  			c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-4.5c-0.1,0-0.1,0-0.1,0.2v14.8c0,0.5-0.3,0.8-0.7,0.8
  			C166.1,37.2,165.8,37,165.8,36.5z"/>
  		<path fill="#FFFFFF" d="M175.4,20.8c0-0.4,0.3-0.7,0.7-0.7h8.9c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-8c-0.1,0-0.1,0-0.1,0.2
  			v6c0,0.1,0.1,0.2,0.1,0.2h6.8c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-6.8c-0.1,0-0.1,0-0.1,0.2v6.3c0,0.1,0.1,0.2,0.1,0.2
  			h8c0.5,0,0.7,0.3,0.7,0.7c0,0.4-0.2,0.7-0.7,0.7h-8.9c-0.4,0-0.7-0.2-0.7-0.7V20.8z"/>
  		<path fill="#FFFFFF" d="M189.3,20.8c0-0.4,0.3-0.7,0.7-0.7h4.5c3.1,0,5,1.4,5.8,3.8c0.4,1.2,0.5,2.2,0.5,4.6s-0.1,3.5-0.5,4.6
  			c-0.8,2.5-2.6,3.8-5.8,3.8H190c-0.4,0-0.7-0.2-0.7-0.7V20.8z M190.8,35.8h3.4c2.5,0,3.9-0.8,4.6-3c0.3-1,0.5-2,0.5-4.2
  			s-0.1-3.1-0.5-4.2c-0.7-2.1-2-3-4.6-3h-3.4c-0.1,0-0.1,0-0.1,0.2v14C190.7,35.7,190.7,35.8,190.8,35.8z"/>
  	</g>
  </g>
  </svg>



// WEBPACK FOOTER //
// ./src/StartButton.js